export const tipoTermoUsoEnum = {
  USUARIO: 'USUARIO',
  FORNECEDOR: 'FORNECEDOR',
  LICENCIADO: 'LICENCIADO',
  PRIVACIDADE: 'PRIVACIDADE',
  AFILIADO: 'AFILIADO',
  SEBRAETEC: 'SEBRAETEC'
};
